import { Dispatch, MiddlewareAPI } from "redux";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import {
  IBasketOrderItem,
  IBasketOrderItems,
} from "../../../../entities/manhattan/order/types";
import { IProductColorsImages } from "../../../../entities/product/types";
import { apiRequest } from "../../api/actions";
import { createErrorNotification } from "../../notification/actions";
import { INotification } from "../../notification/types";
import { AppState } from "../../rootReducers";
import { setError } from "../../ui/actions";
import {
  updateDeviceColorAction,
  updateDeviceColorChangeInProgressAction,
} from "./actions";
import { ChangeDeviceColorRequestData } from "./types";
import { getFlatStructureOfBasketItems } from "../../../../utilites/order";

abstract class IChangeOrderDeviceColorMiddlewareProxy {

  public static callAPI: (
    store: MiddlewareAPI,
    next: Dispatch,
    payload: ChangeDeviceColorRequestData
  ) => void;
  public static handleAPISuccess: (
    next: Dispatch,
    data: ChangeDeviceColorRequestData & { imagePath: string }
  ) => void;
  public static handleAPIError: (
    store: AppState,
    next: Dispatch,
    payload: any
  ) => void;

}

export default class ChangeOrderDeviceColorMiddlewareProxy
implements IChangeOrderDeviceColorMiddlewareProxy
{

  public static callAPI(
    store: MiddlewareAPI,
    next: Dispatch,
    payload: ChangeDeviceColorRequestData
  ): void {
    const { itemId, colorId } = payload;
    const state: AppState = store.getState();

    const basketItem = state.manhattanOrder.order.basket.items
      .map((item: IBasketOrderItems) => {
        const itemFound = item.items.find(
          (innerItem: any) => innerItem.id === itemId
        );

        return itemFound;
      })
      .find((item: IBasketOrderItems) => item !== undefined);

    const productColorImage = basketItem?.productColorsImages.find(
      (imageItem: IProductColorsImages) => imageItem.color.id === colorId
    );
    const data = {
      imagePath: productColorImage?.img1 || "",
      itemId,
      colorId,
    };

    next(
      apiRequest(
        null,
        "PATCH",
        `${ApiUrls.CHANGE_DEVICE_COLOR}/${payload.itemId}`,
        null,
        data,
        MiddlewareEntities.ORDER.CHANGE_DEVICE_COLOR,
        {}
      )
    );

    next(
      updateDeviceColorChangeInProgressAction({
        itemId,
        colorChangeInProgress: true,
      })
    );
  }

  public static handleAPISuccess(
    next: Dispatch,
    data: ChangeDeviceColorRequestData
  ): void {
    next(updateDeviceColorAction(data));
    next(setError(false, MiddlewareEntities.ORDER.CHANGE_DEVICE_COLOR));
    next(
      updateDeviceColorChangeInProgressAction({
        itemId: data.itemId,
        colorChangeInProgress: false,
      })
    );
  }

  public static handleAPIError(
    store: AppState,
    next: Dispatch,
    payload: any
  ): void {
    const { itemId } = payload.data;
    next(setError(true, MiddlewareEntities.ORDER.CHANGE_DEVICE_COLOR));
    next(
      createErrorNotification(
        payload.data as INotification,
        MiddlewareEntities.ORDER.CHANGE_DEVICE_COLOR
      )
    );

    if (payload.data.basketItemId) {
      next(
        updateDeviceColorChangeInProgressAction({
          itemId,
          colorChangeInProgress: false,
        })
      );
    } else {
      const basketItems = getFlatStructureOfBasketItems(store.manhattanOrder.order.basket);

      const basketItemLoading = basketItems.find(
        (item: IBasketOrderItem) => item.colorChangeInProgress === true
      );
      const basketItemId = basketItemLoading?.id;

      next(
        updateDeviceColorChangeInProgressAction({
          itemId: basketItemId,
          colorChangeInProgress: false,
        })
      );
    }
  }

}
